// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tabs-wrapper[data-v-83f3ef32]{padding:0 20px}.tab-save-bar[data-v-83f3ef32]{display:flex;justify-content:flex-end;margin-bottom:14px}.profile-container[data-v-83f3ef32]{max-width:1700px;margin-left:auto;margin-right:auto;padding-left:32px;padding-right:32px}.profile-layout[data-v-83f3ef32]{align-items:flex-start}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
